import { useState } from "react";
import { Moon, Sun } from "lucide-react";

type Theme = "light" | "dark";
const STORAGE_KEY = "site-theme";

/** Modo con el que nace el sitio (lo fija la paleta en styles/theme.css con --theme-base). */
function baseTheme(): Theme {
  const value = getComputedStyle(document.documentElement).getPropertyValue("--theme-base").trim();
  return value === "dark" ? "dark" : "light";
}

function currentTheme(): Theme {
  const chosen = document.documentElement.dataset.theme;
  return chosen === "dark" || chosen === "light" ? chosen : baseTheme();
}

/**
 * Botón claro/oscuro. Cambia data-theme en <html> (los colores del otro modo están en styles/theme.css) y recuerda la
 * elección en el navegador del visitante. index.html aplica esa elección antes de dibujar la página para evitar parpadeos.
 */
export function ThemeToggle({ className = "theme-toggle" }: { className?: string }) {
  const [theme, setTheme] = useState<Theme>(currentTheme);
  const next: Theme = theme === "dark" ? "light" : "dark";
  const toggle = () => {
    document.documentElement.dataset.theme = next;
    try { localStorage.setItem(STORAGE_KEY, next); } catch { /* navegación privada: el cambio dura hasta recargar */ }
    setTheme(next);
  };
  const label = next === "dark" ? "Activar modo oscuro" : "Activar modo claro";
  return (
    <button type="button" className={className} onClick={toggle} aria-label={label} title={label}>
      {next === "dark" ? <Moon aria-hidden="true" strokeWidth={1.75} /> : <Sun aria-hidden="true" strokeWidth={1.75} />}
    </button>
  );
}
